<div dx-resizable="{ handles: 'all', minWidth: 100, maxWidth: 500 }">

<dx-scroll-view data-testid="service-request-scroll-view">
<form #formElement (submit)="onSubmit($event)">
    <dx-form data-testid="form" id="form" class="cards-wide"
    [formData]="requestData"
    [items]="formItems"
    [showValidationSummary]="true"
    [colCount]="formColCount"
    (onInitialized)="onFormInitialized($event)"
    validationGroup="formGroup">

        <dxi-item [colSpan]="formColCount" labelMode="static" dataField="requestType" editorType="dxSelectBox" cssClass="dx-widget"
            [editorOptions]="{ items: requestTypes, valueExpr: 'name', displayExpr: 'name',
                        required: 'true' , searchMode: 'contains', searchEnabled: true, onSelectionChanged: onRequestTypeSelectionChanged, disabled: isEditable }">
            <dxo-label text="Request Type"> </dxo-label>
            <dxi-validation-rule type="required" message="Request Type is required">
            </dxi-validation-rule>
          </dxi-item>
          <div *dxTemplate="let formItemData of 'loanAmountsGridTemplate'">
            <app-loan-amounts-grid
              [loanAmounts]="requestData.loanAmounts"
              [loanData]="loanDataForGrid"
              [showInactiveLoans]="showInactiveLoans"
              [showAmountColumn]="currentRequestType?.toUpperCase() !== 'AUDIT CONFIRM'"
              [shouldDisableCheckbox]="shouldDisableCheckbox"
              [activeLoanCheckboxText]="activeLoanCheckboxText"
              [isGridInEditMode]="isGridInEditMode"
              [loanItemTemplate]="loanItemTemplate"
              (showInactiveLoansChange)="onGridShowInactiveLoansChange($event)"
              (gridEditModeChange)="onGridEditModeChange($event)"
              (loanAmountsChange)="onGridLoanAmountsChange($event)">
            </app-loan-amounts-grid>
          </div>
        <div *dxTemplate="let section of 'fileUploadTemplate'">
          <app-file-upload data-testid="service-request-file-upload"
            labelText=""
            selectButtonText="Browse or drop files here"
            (onFileUploadEventEmitter)="onFileUpload($event)"
            (onFileRemoveEventEmitter)="onFileRemove($event)">
          </app-file-upload>
        </div>
    </dx-form>
       <dx-load-panel data-testid="service-request-load-panel" container=".cards-wide" [position]="{ of: '.content' }" [visible]="isLoading"
      [showPane]="true"></dx-load-panel>
</form>


  </dx-scroll-view>
</div>